import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  Container,
  Box,
  Text,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useDisclosure,
  Image,
  Flex,
} from "@chakra-ui/react";
import Login from "../components/Authentication/Login";
import Signup from "../components/Authentication/Signup";
import { useNavigate } from "react-router-dom";
import VendorSignup from "../components/Authentication/VendorSignup";
import ForgotPassword from "../components/Authentication/ForgotPassword";
import logo from "../components/Pictures/logo.png";

const Homepage = () => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (token) {
      navigate("/chats", { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>ATO | Login</title>
        <meta
          name="description"
          content="ATO - Connect with trusted vendors and professionals. Login, sign up, or join as a vendor to get started."
        />
      </Helmet>
      <Container maxW="xl" centerContent>
        <Box
          d="flex"
          justifyContent="center"
          p={3}
          bg={"white"}
          w="100%"
          m="40px 0 15px 0"
          borderRadius="lg"
          borderWidth="1px"
        >
          <Flex alignItems="center" justifyContent="center" gap={3}>
            <Image
              src={logo}
              alt="ATO Logo"
              boxSize="50px"
              objectFit="contain"
            />
            <Text fontSize="4xl" fontFamily="Work sans" color="black">
              ATO
            </Text>
          </Flex>
        </Box>
        <Box bg="white" w="100%" p={4} borderRadius="lg" borderWidth="1px">
          <Tabs variant="soft-rounded" colorScheme="orange">
            <TabList mb="1em">
              <Tab width="33.33%">Login</Tab>
              <Tab width="33.33%">Sign Up</Tab>
              <Tab width="33.33%">Vendor</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <Login onForgotPassword={onOpen} />
              </TabPanel>
              <TabPanel>
                <Signup />
              </TabPanel>
              <TabPanel>
                <VendorSignup />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
        <ForgotPassword isOpen={isOpen} onClose={onClose} />
      </Container>
    </>
  );
};

export default Homepage;
